import React from "react";
import EditorCanvasView from "components/editor_canvas/editor_canvas_view";
import Types from 'components/editor_canvas/editor_canvas_element_types';
import {dbPlacedItems, dbStories} from "components/firebase";
import {backgrounds} from "components/tools_pane/tools_items";
import {Localization} from "localizations/languages";

class PrintablePage extends React.Component {
    static WIDTH = 1920;
    static HEIGHT = 1080;
    static STORY_TITLE_ID = 'story-title';
    transforming = false;
    placedItems = {};

    constructor(props) {
        super(props);
        this.state = {
            maxZIndex: 0,
            placedItems: {},
            canvasOffsetX: 0,
            canvasOffsetY: 0,
            canvasRect: {
                width: PrintablePage.WIDTH,
                height: PrintablePage.HEIGHT,
            }
        };
        this.canvasRef = React.createRef();
        this._loadData();
    }

    async _loadData() {
        this.story = this.props.story;
        if (!this.props.storyDoc || this.props.page === undefined) return;
        this.placedItems = {};

        this.storyDoc = this.props.storyDoc;
        this.page = this.props.page;
        this.pageData = (await this.props.page.get()).data();
        if (!!this.unsubscribe) this.unsubscribe();
        this.unsubscribe = dbPlacedItems
            .where('owner', '==', this.storyDoc.data().owner)
            .where('story', '==', dbStories.doc(this.storyDoc.id))
            .where('page', '==', this.page)
            .onSnapshot((snapshot => {
                snapshot.docChanges().forEach((change) => {
                    let data = change.doc.data();
                    if (change.type === 'removed') {
                        delete this.placedItems[data.uuid];
                    } else {
                        this.placedItems[data.uuid] = data;
                    }
                });
                this.setState({
                    placedItems: this.placedItems
                });
                if (!!this.props.handleLoaded()) this.props.handleLoaded();
                this.unsubscribe();
            }));
    }

    render() {
        return <div style={{width: PrintablePage.WIDTH, height: PrintablePage.HEIGHT}} id={this.props.id}>
            <EditorCanvasView
                canvasRef={this.canvasRef}
                readOnly={true}
                printable={true}
                storyData={this.storyDoc.data()}
                bgImage={this._getCurrentBg()}
                {...this.state} {...this.props}
            />
        </div>;
    }

    _getCurrentBg() {
        if (!this.pageData) return;
        // load bg from active page
        let pdoc = this.pageData;
        if (!pdoc) {
            console.log("ERROR page undefined");
        }
        if (!pdoc) return null;
        let bg = backgrounds[pdoc.background];
        return !!bg ? bg.img : null;
    }

    onTitleUpdate(pitem) {
        this.placedItems[pitem.uuid] = pitem;
        this.story.update({
            ptitle: pitem,
            title: pitem.textOverlay.content
        });
    }

    onTransformStart(pitem) {
        this.transforming = true;
        if (!!this.props.onDragStart) this.props.onDragStart();
        this._onPlacedItemClick(pitem.uuid);
    }

    onTransformEnd(pitem) {
        setTimeout(() => {
            this.transforming = false;
            if (!!this.props.onDragEnd) this.props.onDragEnd();
        }, 100);
    }

    static getTitlePlacedItem() {
        let pitem = PrintablePage.defaultPlacedItem.get(Types.PLACED_TEXTBOX);
        pitem.textOverlay.content = Localization.current.translation1;
        pitem.textOverlay.styles = {
            fontWeight: 'bold',
            color: 'white',
            fontSize: 3.4,
            textShadow: '2px 2px 20px #000000'
        };
        pitem.position.x = 88;
        pitem.position.y = 40;
        pitem.position.scaleX = 20;
        pitem.position.scaleY = 2.6;
        pitem.position.width /= 2;
        pitem.position.height /= 2;
        pitem.uuid = PrintablePage.STORY_TITLE_ID;
        return pitem;
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        if (!!this.unsubscribe) this.unsubscribe();
    }
}

export default PrintablePage;
